import errorMessage from './error-message';

export default {
  errorMessage,
};
